import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ImageCacheService } from '../services/imageCache.service';

@Pipe({
  name: 'authImage'
})
export class AuthImagePipe implements PipeTransform {

  constructor(
    private imageCacheService: ImageCacheService,
    protected sanitizer: DomSanitizer
  ) { }

  async transform(src: string, type: string, iam: string, url?: string, avOpts?: Array<any>, useTypeError?: boolean): Promise<any> {

    if (src && url) {

      const imageData = await this.imageCacheService.getImageData(src, iam);

      if (imageData.type === 'error') {
        if (useTypeError) {
          type = 'error';
        } else {
          return;
        }
      }

      if (imageData.type === 'error' && type !== 'error') {
        return;
      }

      switch (type) {

        case 'image': return this.sanitizer.bypassSecurityTrustUrl(imageData.result);
        case 'background': return this.sanitizer.bypassSecurityTrustStyle(`url(${imageData.result})`);
        case 'stringOnly': return imageData.result;
        case 'av':
          if (avOpts[0].avType == 'audio') {

            let audio = `
                            <audio controls style="margin-top: 50px; margin-bottom: 20px;">
                                <source src="${imageData.result}">
                                Seu navegador não suporta exibição de video.
                            </audio>
                          `
            return this.sanitizer.bypassSecurityTrustHtml(audio);
          }

          if (avOpts[0].avType == 'video') {

            let video = `
                            <video
                              preload="none"
                              controls
                              [muted]="${avOpts[0].noaudio}"
                              style="width: 100%"
                            >
                              <source src="${imageData.result}">
                              Seu navegador não suporta exibição de video.
                          </video>
                          `
            return this.sanitizer.bypassSecurityTrustHtml(video);
          }
          return;
        case 'error': return 'error';
      }

    } else {

      switch (type) {

        case 'image':
          return src
        case 'background':
          return this.sanitizer.bypassSecurityTrustStyle(`url(${src})`);
      }
    }
  }
}

